// src/lib/fetchEventsGrid.ts
import type { EventProduct } from "@/components/pageBuilder/components/FeaturedEvents";

const BASE = (process.env.NEXT_PUBLIC_API_URL || "").replace(/\/$/, "");

export type FetchEventsGridResult = {
  products: EventProduct[];
  total: number;
};

export async function fetchEventsGrid(
  lang: string,
  perPage = 50,
  category?: number | string | null
): Promise<FetchEventsGridResult> {
  if (!BASE) return { products: [], total: 0 };

  const params = new URLSearchParams({
    lang,
    per_page: String(perPage),
    status: "publish",
    _embed: "1",
    include_fooevents: "1",
  });

  if (category) params.set("product_cat", String(category));

  const url = `${BASE}/wp-json/bright/v1/products?${params.toString()}`;

  try {
    const res = await fetch(url, {
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
    });
    if (!res.ok) return { products: [], total: 0 };

    const data = (await res.json()) as unknown;
    const products = Array.isArray(data) ? (data as EventProduct[]) : [];
    const total = Number(res.headers.get("X-WP-Total") || products.length);

    return { products, total };
  } catch {
    return { products: [], total: 0 };
  }
}